module.exports = __webpack_public_path__ + "media/images/product/b2-6613143917d56cd2cf97c137060aa450.png";